import { InjectionToken } from '@angular/core';

export { tenantGuard } from './lib/services/tenant.guard';

export const APP_CONFIG_SERVICE = new InjectionToken('App config service');
